import { IconType } from 'react-icons'
import { LuMapPin, LuPhone, LuVideo } from 'react-icons/lu'

import {
  InPersonMeetingFormat,
  MeetingFormatChoice,
} from '@/components/integration/nylas/scheduler/types'
import { MeetingFormat } from '@/types/misc'

/**
 * How each meeting format is shown in the booking summary screen.
 */
export const MEETING_FORMAT_DETAILS: Record<
  MeetingFormat,
  { icon: IconType; label: string }
> = {
  video: { icon: LuVideo, label: 'Video call' },
  phone: { icon: LuPhone, label: 'Phone call' },
  in_person_office: { icon: LuMapPin, label: 'In person (office)' },
  in_person_client_home: {
    icon: LuMapPin,
    label: "In person (client's home)",
  },
}
/**
 * How the scheduler turns the two questions it asks ("How would you like to
 * meet?" and, for in person, "Where?") into the format to book in. Pure
 * functions so they can be unit tested without the hook.
 */

export const IN_PERSON_MEETING_FORMATS: InPersonMeetingFormat[] = [
  'in_person_office',
  'in_person_client_home',
]

export const MEETING_FORMAT_CHOICE: Record<
  MeetingFormatChoice,
  MeetingFormatChoice
> = {
  video: 'video',
  phone: 'phone',
  in_person: 'in_person',
}

/**
 * One "In person" button covers both in-person formats; "Where?" (see
 * InPersonPlacePicker) decides between them when both are offered.
 */
export const MEETING_FORMAT_CHOICE_OPTIONS: Array<{
  formatChoice: MeetingFormatChoice
  label: string
}> = [
  {
    formatChoice: 'video',
    label: 'Teams video call',
  },
  {
    formatChoice: 'phone',
    label: 'Phone call',
  },
  {
    formatChoice: 'in_person',
    label: 'In person',
  },
]
